/* SANO — correções de conversão, 16-10-2026. Sem alteração de preços, stock ou pagamentos. */
(function () {
  'use strict';
  if (window.sanoConversion20261016) return;
  window.sanoConversion20261016 = true;

  var whatsapp = 'https://wa.me/351965370087?text=' + encodeURIComponent('Olá! Preciso de ajuda com uma compra na SANO.');
  var productPage = !!(window.theme && window.theme.pageType === 'product') || /^\/products\//.test(location.pathname);
  var cartPage = /^\/cart\/?$/.test(location.pathname);

  function primaryButton() {
    return document.querySelector('.product-form__payment-container button[type="submit"], form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"]');
  }

  function cleanLegacyOverlays() {
    ['sano-sticky-phone-v15', 'sano-cart-upsell-v15', 'sano-trust-strip-v15', 'sano-guarantee-box-v15'].forEach(function (id) {
      var element = document.getElementById(id);
      if (element) element.remove();
    });
    document.body.classList.remove('sano-has-sticky-phone');
    // A barra antiga MARINUS continua a ser criada pelo custom.js; o CSS desativa-a.
    // O seletor de variantes e os respetivos eventos mantêm-se intactos.
  }

  function productHelp() {
    if (!productPage || document.getElementById('sano-buy-help-20261016')) return;
    var payment = document.querySelector('.product-form__payment-container');
    if (!payment) return;
    var help = document.createElement('div');
    help.id = 'sano-buy-help-20261016';
    help.className = 'sano-buy-help';
    help.innerHTML = '<p><strong>Precisa de ajuda antes de comprar?</strong></p>' +
      '<a href="' + whatsapp + '" target="_blank" rel="noopener">Falar com a SANO pelo WhatsApp</a>' +
      '<p class="sano-small">Veja os métodos e as instruções de pagamento no checkout. ' +
      '<a href="/policies/shipping-policy">Entregas</a> · <a href="/policies/refund-policy">Devoluções</a></p>';
    payment.insertAdjacentElement('afterend', help);
  }

  function productSticky() {
    if (!productPage || document.getElementById('sano-mobile-buy-20261016')) return;
    var buy = primaryButton();
    if (!buy) return;
    var bar = document.createElement('div');
    bar.id = 'sano-mobile-buy-20261016';
    bar.className = 'sano-mobile-buy';
    bar.hidden = true;
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Adicionar ao carrinho';
    button.setAttribute('aria-label', 'Adicionar o produto selecionado ao carrinho');
    bar.appendChild(button);
    document.body.appendChild(bar);
    document.body.classList.add('sano-product-mobile-space');
    var buyVisible = true;
    var mobile = window.matchMedia('(max-width: 749px)');
    function refresh() {
      var current = primaryButton();
      var blocked = !current || current.disabled || current.getAttribute('aria-disabled') === 'true';
      button.disabled = blocked;
      button.textContent = blocked ? 'Indisponível de momento' : 'Adicionar ao carrinho';
      // Nunca sobrepor o CTA original: a barra só aparece depois de a área de compra sair do ecrã.
      bar.hidden = !mobile.matches || buyVisible || blocked;
    }
    button.addEventListener('click', function () {
      var current = primaryButton();
      if (current && !current.disabled) current.click();
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting;
        refresh();
      }, { threshold: 0 });
      observer.observe(buy);
    } else {
      // Sem observador, não criar um obstáculo adicional à compra.
      buyVisible = true;
    }
    new MutationObserver(refresh).observe(buy, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    window.addEventListener('resize', refresh, { passive: true });
    document.addEventListener('change', refresh, true);
    refresh();
  }

  function movePackComparison() {
    if (!productPage) return;
    var comparison = document.getElementById('sano-upsell-pack3');
    var help = document.getElementById('sano-buy-help-20261016');
    if (comparison && help && comparison.dataset.sanoPosition !== 'buy-area') {
      // Usa a comparação já existente no tema: não recalcula preços nem altera o catálogo.
      help.insertAdjacentElement('afterend', comparison);
      comparison.dataset.sanoPosition = 'buy-area';
    }
  }

  function clarifyNavigation() {
    document.querySelectorAll('a[href="/"], a[href="https://sano.pt/"]').forEach(function (link) {
      if ((link.textContent || '').trim() === 'Home') link.textContent = 'Início';
    });
    var buy = primaryButton();
    if (productPage && buy && !buy.disabled) buy.textContent = 'Adicionar ao carrinho';
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (button) {
      if (button.tagName === 'INPUT') button.value = 'Finalizar encomenda';
      else button.textContent = 'Finalizar encomenda';
    });
    if (cartPage) {
      var main = document.getElementById('main');
      var walker = main && document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
      var node;
      while (walker && (node = walker.nextNode())) {
        if (node.parentElement.closest('script, style, noscript')) continue;
        node.nodeValue = node.nodeValue.replace(/Você economizou/g, 'Poupa').replace(/Continuar comprando/g, 'Continuar a comprar');
      }
    }
  }

  function boot() {
    cleanLegacyOverlays();
    clarifyNavigation();
    productHelp();
    movePackComparison();
    productSticky();
    if (cartPage) document.body.classList.add('sano-cart-clear');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  // Uma única passagem após carregamento cobre elementos gerados pelas aplicações, sem ciclos permanentes.
  window.addEventListener('load', boot, { once: true });
})();
